import React, { Component } from "react"
import { Table, Row, Pagination } from "antd"
import "./Index.scss"
import config from "app/config"
import downloadIcon from "app/styles/images/sp/download.svg"
import { observer, inject } from 'mobx-react'
import { PREPARE_RUN, RUNNING } from 'app/utils/const'
import { observable } from "mobx"

@inject('auth') @observer
export default class ReportDetail extends Component {
  @observable resultAneu = ''
  @observable resultCNV = ''
  @observable resultGender = ''
  constructor(props) {
    super(props)
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      activeReportIndex: 0,
      currentPage: 1,
      reportListArr: [],
    }
  }

  onCloseRequest() {
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false
    }
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

  componentWillMount() {
    this.initNav(this.props.index)
  }

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1
    })
  }

  changeReport = (index, record) => {
    this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex: index
    })
    this.props.dataSwitch(index, record)
  }

  changePage = (e) => {
    let activeReportIndex = (e - 1) * 10
    let record = this.props.reportList[activeReportIndex]

    this.renderReportList(e)
    this.setState({
      currentPage: e,
      activeReportIndex
    })
    this.changeReport(activeReportIndex, record)
  }

  renderReportList = (pageNumber) => {
    let { reportList } = this.props.data
    let reportListArr = []
    let endNum = pageNumber * 10
    if (reportList && endNum > reportList.length) {
      endNum = reportList.length
    }
    for (let currenNum = (pageNumber - 1) * 10; currenNum < endNum; currenNum++) {
      const { state } = reportList[currenNum]
      if (state !== PREPARE_RUN && state !== RUNNING) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => this.changeReport(currenNum, reportList[currenNum])}
            className={this.state.activeReportIndex === currenNum ? "active report" : "report"}
          >
            {reportList[currenNum].sampleName}
          </li>
        )
      }
    }
    return reportListArr
  }
  renderCaseImages = (title, detailData) => {
    return (
      <div className="detail-card">
        <div className="title-wrapper"><h3 className="border-left-primary detail-card-title">{title}</h3></div>
        <div>
          {detailData.ecsCnvResultImgs && detailData.ecsCnvResultImgs.map((img, index) => (
            <div>
              <img alt="" key={index} src={img.cnvResultImg || []} />
              <div className="sample-img-info">
                <span>{img.sampleName || ""}</span>
                <span>{img.sampleType || ""}</span>
                <span>{img.sex || ""}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  renderSampleImage = (title, detailData) => {
    return (
      <div className="detail-card">
        <h3 className="border-left-primary detail-card-title">{title}</h3>
        <div><img alt="" src={!this.isEmptyObj(detailData) ? detailData.imgCnvResult.samplePoint : []} /></div>
        <div className="sample-img-info">
          <span>{!this.isEmptyObj(detailData) ? detailData.sampleName : ""}</span>
          <span>{!this.isEmptyObj(detailData) ? detailData.sampleType : ""}</span>
          <span>{!this.isEmptyObj(detailData) ? detailData.sex : ""}</span>
        </div>
      </div>
    )
  }

  render() {
    const {
      currentPage,
    } = this.state
    let {
      data = {},
      detailData,
    } = this.props
    const columnsData = [
      {
        title: "SampleID",
        dataIndex: "SampleID",
        className: "ta-l",
      }, {
        title: "Total_bases",
        dataIndex: "Total_bases",
        className: "ta-l"
      }, {
        title: "Dup_bases",
        dataIndex: "Dup_bases",
        className: "ta-l"
      }, {
        title: "Mapped_bases",
        dataIndex: "Mapped_bases",
        className: "ta-l"
      }, {
        title: "Target_bases",
        dataIndex: "Target_bases",
        className: "ta-l"
      }, {
        title: "Target_mean_depth",
        dataIndex: "Target_mean_depth",
        className: "ta-l"
      }, {
        title: "Target_cov_1x",
        dataIndex: "Target_cov_1X",
        className: "ta-l"
      }, {
        title: "Target_cov_10x",
        dataIndex: "Target_cov_10X",
        className: "ta-l"
      },{
        title: "Target_cov_20x",
        dataIndex: "Target_cov_20X",
        className: "ta-l"
      }, {
        title: "Target_cov_30x",
        dataIndex: "Target_cov_30X",
        className: "ta-l"
      }
    ]
    const cnvColumns = [
      {
        title: "Chr",
        dataIndex: "chr",
        className: "ta-l",
      },
      {
        title: "Start",
        dataIndex: "start",
        className: "ta-l",
      },
      {
        title: "End",
        dataIndex: "end",
        className: "ta-l",
      },
      {
        title: "Length",
        dataIndex: "length",
        className: "ta-l",
      },
      {
        title: "Name",
        dataIndex: "name",
        className: "ta-l",
      },
      {
        title: "Percent",
        dataIndex: "percent",
        className: "ta-l",
      },
      {
        title: "Detail",
        dataIndex: "detail",
        className: "ta-l",
      },
    ]
    return (
      <Row type="flex" className="ecs-report-detail">
        <div ref="content" className="content">
          <div id="detailTop" className="detail-card border-left-paimary first">
            <div className="info-group">
              <label>数据类型：</label>
              <p>{data ? data.appName === "expanded Carrier screening" ? "ECS" : data.appName : ""}</p>
            </div>
            <div className="info-group">
              <label>批次号：</label>
              <p>{data.groupName || data.name}</p>
            </div>
            <div className="info-group">
              <label>样本编号：</label>
              <p>{!this.isEmptyObj(detailData) ? detailData.sampleName : []}</p>
            </div>
            <div className="info-group">
              <label>性别：</label>
              <p>{!this.isEmptyObj(detailData) ? detailData.sex : []}</p>
            </div>
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">测序质量统计</h3>
            <Table
              columns={columnsData}
              rowKey={record => record.Total_Reads + "statistical"}
              dataSource={
                (!this.isEmptyObj(detailData) && Object.keys(detailData.statistical).length > 0)
                  ? [detailData.statistical] : []
              }
              pagination={false} />
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">Per Base Sequence Quality</h3>
            <div className="quality-image-wrap">
              <img
                className="quality-image"
                alt=""
                src={!this.isEmptyObj(detailData) ?
                  detailData.imgBamstats.quals2 :
                  []}
              />
            </div>
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">Per Base Sequence Content</h3>
            <div className="quality-image-wrap">
              <img
                className="quality-image"
                alt=""
                src={!this.isEmptyObj(detailData) ?
                  detailData.imgBamstats.acgtCycles :
                  []}
              />
            </div>
            <div>
            </div>
          </div>
          <div className='detail-card'>
            <h3 className="border-left-primary detail-card-title">SNPINDEL</h3>
            <div>
              文件名：{!this.isEmptyObj(detailData) ? detailData.sampleName + '.ACMG_NOT_BA1_reform.tsv.most.rank' : ''}
              <a
                href={`${config.backend}/ecs/reports/${!this.isEmptyObj(detailData) && detailData.reportId}/snpindel`}
                title="下载报告"
                className="snpindel-download"
              >
                下载
              </a>
            </div>
          </div>
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">CNV结果统计</h3>
            <Table
              columns={cnvColumns}
              rowKey={record => record.start + "cnvResultSummaries"}
              dataSource={!this.isEmptyObj(detailData) ? detailData.cnvResultSummaries : []}
              pagination={false} />
          </div>
          {detailData.sampleType === 'case' ?
            (<div>
              {this.renderCaseImages('control样本', detailData)}
              {this.renderSampleImage('case样本', detailData)}
            </div>) :
            this.renderSampleImage('control样本', detailData)}
          <div className="wrapper-download">
            <a
              href={`${config.backend}/ecs/reports/${!this.isEmptyObj(detailData) && detailData.reportId}/download`}
              title="下载报告"
              className="download"
            >
              <img src={downloadIcon} alt="下载" />
            </a>
          </div>
        </div>
        <div className="reportNav">
          <div className="title">本组数据</div>
          <ul className="reports">
            {data.reportList && this.renderReportList(currentPage)}
          </ul>
          <Pagination
            className="pagination"
            size="small"
            pageSize={10}
            total={
              (data.reportList || []).filter(item =>
                item.state !== PREPARE_RUN && item.state !== RUNNING
              ).length
            }
            current={currentPage}
            onChange={(e) => this.changePage(e)}
          />
        </div>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/ecs/ReportDetail/index.js